import { colorTokens } from '../../../../shared/styles/theme'

export type Accent = {
  primary: string
  primaryHover: string
  primaryFg: string
}

type Brand = {
  accent: Accent
  label: string
  badgeBg: string
}

// 杏林堂薬局のカンパニーカラーは公式サイトのロゴから採取した2色(#00A896 ティール / #FFEC00 黄)。
// CTAボタンなど白文字と重ねる面はティールを使う(白文字とのコントラスト比が 2.98:1 で
// WCAG AA(4.5:1)未達だったため、色相・彩度は保ったまま暗くして 4.98:1 まで上げてある。
// primaryHoverも同系統で追随)。ラベルバッジは黄地+ティール文字でロゴ2色そのまま組む。
const KYORINDO_BRAND: Brand = {
  accent: { primary: '#007E70', primaryHover: '#00695C', primaryFg: '#FFFFFF' },
  label: '杏林堂薬局環境',
  badgeBg: '#FFEC00',
}

// userId → 表示ブランドの静的テーブル。db側の文字列(pharmacy.name)には依存しない
// (pharmacy.name は "杏林堂薬局_根洗店" のように内部表記の "_" を含むため)。
// 該当なしなら既定色のまま・ラベルは付かない = 他ユーザーへの影響ゼロ。
//
// **検証用アカウント(admin@example.com)は載せない。** 実店舗の環境を写して確かめる用途で
// 本番・staging の両方を杏林堂として登録していたが、この口はデモにも使う。他社様へお見せする
// 場に「杏林堂薬局環境」のバッジと杏林堂のカンパニーカラーが出るのは事故なので、
// **顧客の実アカウントだけを載せる**。検証で見た目を確かめたいときは実アカウントで入る。
const BRAND_BY_USER_ID: Record<string, Brand> = {
  'adb78be4-c4db-4b5d-80a3-d628196df948': KYORINDO_BRAND, // [本番] 杏林堂薬局_根洗店
}

export const getBrand = (userId: string | null): Brand | undefined =>
  userId ? BRAND_BY_USER_ID[userId] : undefined

// 未登録ユーザーは既定の accent トークンをそのまま返す
// (colorTokens.accent は Accent の 3 フィールドを満たすので、既定値の写しを別に持たない)。
export const getAccent = (userId: string | null): Accent =>
  getBrand(userId)?.accent ?? colorTokens.accent
